import { getConfiguration } from '@app/ducks';
import { useAmplitude } from '@app/utils/analytics/useAmplitude';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

interface Props {
  url: string;
}
export const ClientLogo = React.memo(({ url }: Props) => {
  const config = useSelector(getConfiguration);
  const { companyName, logoImageDark } = config;
  const { trackEvent } = useAmplitude();

  const handleClick = () => {
    trackEvent({ name: 'topbar.logo.click' });
  };

  const [isBroken, setIsBroken] = React.useState(false);

  const handleError = React.useCallback(() => setIsBroken(true), []);
  const hasValidImage = !isBroken && !isEmpty(config.logoImageDark);

  const name = isDefined(companyName) ? companyName : 'Company logo';
  const image =
    hasValidImage ?
      <img onError={handleError} src={logoImageDark} alt={name} className="h-full max-h-8 min-w-full object-contain" />
    : name;

  return (
    <h1 className="h-full min-w-max shrink-0">
      <Link to={url} className="block h-full rounded-regular focus-visible:focus-outline" onClick={handleClick}>
        {image}
      </Link>
    </h1>
  );
});
